import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator that checks if at least one control in the form group is true.
 */
export const customValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  if (!(control instanceof FormGroup)) {
    return null; // Should be applied to a FormGroup
  }

  const controls = control.controls;
  let hasAtLeastOneTrue = false;

  //create a list of the toggle controls to check only the toggle values
  const toggleControls = ['cciToggle', 'aocToggle', 'cqiToggle', 'qsiToggle', 'ebuiltToggle', 'ebuiltPlusToggle'];

  for (const key in controls) {
    if (Object.prototype.hasOwnProperty.call(controls, key)) {
      if (toggleControls.includes(key) && controls[key].value === true) {
        hasAtLeastOneTrue = true;
        break;
      }
    }
  }

  // If no control is true, return a validation error object.
  return hasAtLeastOneTrue ? null : { atLeastOneRequired: true };
}